import { render, staticRenderFns } from "./SubscribeDiaspora.vue?vue&type=template&id=07b6f30a&scoped=true&"
import script from "./SubscribeDiaspora.vue?vue&type=script&lang=js&"
export * from "./SubscribeDiaspora.vue?vue&type=script&lang=js&"
import style0 from "./SubscribeDiaspora.vue?vue&type=style&index=0&id=07b6f30a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b6f30a",
  null
  
)

export default component.exports